import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { db } from '../../../firebase';
import { collection, getDocs } from 'firebase/firestore';

const EditRoleModal = ({ show, handleClose, role, handleSave }) => {
    const [nom, setNom] = useState(role.nom);
    const [permissions, setPermissions] = useState(role.permissions);
    const [allPermissions, setAllPermissions] = useState([]);

    useEffect(() => {
        setNom(role.nom);
        setPermissions(role.permissions);
    }, [role]);

    useEffect(() => {
        const fetchPermissions = async () => {
            try {
                const permissionsCollection = collection(db, 'permissions');
                const permissionsSnapshot = await getDocs(permissionsCollection);
                const permissionsList = permissionsSnapshot.docs.map(doc => ({
                    id: doc.id,
                    nom: doc.data().nom
                }));
                setAllPermissions(permissionsList);
            } catch (error) {
                console.error("Error fetching permissions: ", error);
            }
        };

        fetchPermissions();
    }, []);

    const handleCheckboxChange = (permissionId) => {
        if (permissions.includes(permissionId)) {
            setPermissions(permissions.filter(id => id !== permissionId));
        } else {
            setPermissions([...permissions, permissionId]);
        }
    };

    const saveChanges = () => {
        handleSave({ ...role, nom, permissions });
        handleClose();
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Modifier le rôle</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group controlId="formNom">
                        <Form.Label>Nom</Form.Label>
                        <Form.Control
                            type="text"
                            value={nom}
                            onChange={(e) => setNom(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group controlId="formPermissions">
                        <Form.Label>Permissions</Form.Label>
                        {allPermissions.map(permission => (
                            <Form.Check
                                key={permission.id}
                                type="checkbox"
                                label={permission.nom}
                                checked={permissions.includes(permission.id)}
                                onChange={() => handleCheckboxChange(permission.id)}
                            />
                        ))}
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Annuler
                </Button>
                <Button variant="primary" onClick={saveChanges}>
                    Enregistrer
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditRoleModal;
